export default __webpack_public_path__ + "static/coll-energy-iron__core-360-free-01-0879dd126a632b178968d3f95a9e95a0.jpg";